// src/components/HomePage.jsx
import React, { useState } from "react";
import "./createProfile.css";

export default function CreateProfile(props) {
  const { onViewSelect } = props;

  const [email] = useState(() => localStorage.getItem("signupEmail") || "");
  const [username] = useState(() => localStorage.getItem("signupUsername") || "");

  function handleSave() {
    sessionStorage.setItem("authMode", "Login");
    onViewSelect("loginSignup");
  }

  return (
    <div className="home-container">
      <div className="home-card">
        <div className="section-box">
          <h3 className="login-title">My Profile</h3>

          <div className="team-member">
            <div className="team-avatar"></div>
          </div>

          <div className="inputs">
            <div className="input">
              <input type="text" placeholder="Name" />
            </div>
            <div className="input">
              <input type="email" placeholder="Email Address" value={email} readOnly />
            </div>
            <div className="input">
              <input type="text" placeholder="Username" value={username} readOnly />
            </div>

            <div className="input">
              <input type="text" placeholder="Bio" />
            </div>
            <div className="input">
              <input type="text" placeholder="Status" />
            </div>

            <div className="input">
              <select name="eventInterests" defaultValue="">
                <option value="" disabled>
                  Event Interests
                </option>
                <option value="concerts">Concerts</option>
                <option value="sports">Sports</option>
                <option value="theater">Theater</option>
                <option value="festivals">Festivals</option>
                <option value="conferences">Conferences</option>
                <option value="workshops">Workshops</option>
              </select>
            </div>

            <div className="input">
              <select name="personalInterests" defaultValue="">
                <option value="" disabled>
                  Personal Interests
                </option>
                <option value="music">Music</option>
                <option value="art">Art</option>
                <option value="food">Food & Dining</option>
                <option value="fitness">Fitness</option>
                <option value="technology">Technology</option>
                <option value="travel">Travel</option>
                <option value="reading">Reading</option>
              </select>
            </div>
          </div>

          <button className="home-button" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}